import { connect } from 'react-redux'

import { getMessagesTranslator } from '@layers-frontend/commons/store/selectors/messages'

const mapStateToProps = state => ({ t: getMessagesTranslator(state) })

export const withTranslator = connect(mapStateToProps)

export default withTranslator
